import React, { Component } from 'react'
import Modal from 'react-modal'
import CacheKeys from '../../../../cache/CacheKeys'
import CacheManager from '../../../../cache/CacheManager'
import RestApiUtils from '../../../../apiclient/moebli/RestApiUtils'
import RepaymentRemarksModalUI from './RepaymentRemarksModalUI.js'

class RepaymentRemarksModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      submitted: false,
      status: null,
      remarks: this.props.selectedRepayment && this.props.selectedRepayment.remarks || '',
      remarksError: null,
      dsraDipInterestWaived: this.props.selectedRepayment && this.props.selectedRepayment.dsraDipInterestWaived || 'false',
      leviedAmount: this.props.selectedRepayment ? this.props.selectedRepayment.leviedAmountF : '',
      leviedAmountError: null,
      waivedAmount: this.props.selectedRepayment ? this.props.selectedRepayment.waivedAmountF : '',
      waivedAmountError: null,
      tdsAmount: '',
      tdsAmountError: null
    }
  }

  render() {

    let booleanSelectList = [
      { key: 'true', value: 'Yes' },
      { key: 'false', value: 'No' },
    ]

    return (
      <RepaymentRemarksModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        status={this.state.status}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.onCancelClick}
        // form fields
        remarks={this.state.remarks}
        dsraDipInterestWaived={this.state.dsraDipInterestWaived}
        onRemarksChange={(event) => { this.setState({ remarks: event.target.value }) }}
        onRemarksBoolChange={(event) => { this.setState({ dsraDipInterestWaived: event.target.value }) }}
        remarksError={this.state.remarksError}
        setRemarksError={(error) => { this.setState({ remarksError: error }) }}
        booleanSelectList={booleanSelectList}
        // form fields
        leviedAmount={this.state.leviedAmount}
        onLeviedAmountChange={(event) => { this.setState({ leviedAmount: event.target.value }) }}
        leviedAmountError={this.state.leviedAmountError}
        setLeviedAmountError={(error) => { this.setState({ leviedAmountError: error }) }}
        //
        waivedAmount={this.state.waivedAmount}
        onWaivedAmountChange={(event) => { this.setState({ waivedAmount: event.target.value }) }}
        waivedAmountError={this.state.waivedAmountError}
        setWaivedAmountError={(error) => { this.setState({ waivedAmountError: error }) }}
        //
        tdsAmount={this.state.tdsAmount}
        onTdsAmountChange={(event) => { this.setState({ tdsAmount: event.target.value }) }}
        tdsAmountError={this.state.tdsAmountError}
        setTdsAmountError={(error) => { this.setState({ tdsAmountError: error }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  componentDidUpdate(prevProps) {
    let repayment = this.props.selectedRepayment
    if (!repayment ||
      prevProps.selectedRepayment && prevProps.selectedRepayment.scheduledDate === repayment.scheduledDate)
      return

    if (repayment.status == 'paid' || repayment.status == 'initiated') {
      this.setState({
        remarks: repayment.remarks,
        status: repayment.status,
        submitted: false,
        errorList: null
      })
    }

    if (repayment.status == 'unpaid') {
      this.setState({
        remarks: repayment.remarks,
        dsraDipInterestWaived: repayment.dsraDipInterestWaived,
        leviedAmount: repayment.leviedAmountF,
        waivedAmount: repayment.waivedAmountF,
        status: repayment.status,
        submitted: false,
        errorList: null
      })
    }
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/repayments/scheduledDates/${this.props.selectedRepayment.scheduledDate}/remarks`,
      this.onSubmitCallback, {
      remarks: this.state.remarks,
      dsraDipInterestWaived: this.state.dsraDipInterestWaived,
      leviedAmountF: this.state.leviedAmount,
      waivedAmountF: this.state.waivedAmount,
      tdsAmountF: this.state.tdsAmount
    }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
        this.props.onRefreshClick('noBusy')
      }, 100)
    }
  }

  onCancelClick = () => {
    this.setState({
      errorList: null,
      submitted: false,
    })
    this.props.onCancelClick()
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default RepaymentRemarksModalSF
